<template>
    <div>
        <el-card class="box-card" :style="{ 'margin-bottom': (margin ? margin : '10px') }">
            <div slot="header" class="header">
                <icon v-if="icon" :level="icon" class="card-icon"></icon>
                <div>
                    <a v-if="link" :href="link">
                        <h2>{{ title }}</h2>
                    </a>
                    <h2 v-else>{{ title }}</h2>
                    <small class="date color-dark">{{date | date}}</small>
                </div>
            </div>
            <div class="p-20">
                {{description}}
                <slot class="float-right"></slot>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    props: [ 'title', 'link', 'date', 'icon', 'description', 'margin' ],
    data () {
        return {

        }
    },
    methods: {

    }
}
</script>

<style lang="scss">
    .box-card {
        .el-card {
            &__header {
                padding: 10px 20px 0 20px !important;
                border-bottom: none !important;
            }
        }
        .card-icon i {
            font-size: 25px !important;
            margin-right: 10px;
            margin-top: 10px;
        }
        .header {
            vertical-align: middle;
            display: flex;
        }
        h2 {
            display: inline-block;
            margin-bottom: 0;
        }

        .date {
            margin-top: 0px;
            display: block;
        }
    }




</style>
